module.exports = __webpack_public_path__ + "img/05.b599a9f2.png";